import React from "react";
import "./App.css";
import { Toaster } from "./components/ui/sonner";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { About } from "./components/About";
import { Services } from "./components/Services";
import { WhyChooseUs } from "./components/WhyChooseUs";
import { Projects } from "./components/Projects";
import { TechnicalSpecs } from "./components/TechnicalSpecs";
import { Testimonials } from "./components/Testimonials";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";

function App() {
  return (
    <div className="App">
      <div id="home">
        <Header />
        <Hero />
      </div>
      <About />
      <Services />
      <WhyChooseUs />
      <Projects />
      <TechnicalSpecs />
      <Testimonials />
      <Contact />
      <Footer />
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
